import { Component, Element, Prop, Host, h, State } from '@stencil/core';
import type { CssClassMap } from '../../../helpers/utils/interfaces';
import {
  addClass,
  removeClass,
  hasClass,
  addAttribute,
  removeAttribute,
  isEnterKey,
} from '../../../helpers/helpers';

@Component({
  tag: 'cms-accordion-item',
  styleUrl: 'cms-accordion-item.scss',
  shadow: true,
})
export class CmsAccordionItem {
  /**
   * reference the host element
   */
  @Element() hostElement: HTMLElement;

  /**
   * Property for the accordion headline
   */
  @Prop() acHeadline!: string;
  /**
   * Additional attributes for the accordion details
   */
  @Prop() acDetailsAttributes: string;
  /**
   * Additional attributes for the accordion headline
   */
  @Prop() acHeadlineAttributes: string;
  /**
   * Property to set the first item is oben
   */
  @Prop() firstItemIsOpen: false | true;

  /*   @State() open = false; */
  private open: boolean;
  @State() fakeSate = {};
  private transitionSpeed = 300;

  private acDetails: HTMLElement;

  private acSummary: HTMLElement;

  private acDetailsContent: HTMLElement;
  private isClosingClass = 'is-closing';

  private isClosedClass = 'is-closed';

  connectedCallback() {
    this.open = this.firstItemIsOpen;
    if (this.open) {
      this.fakeSate = {};
    }
  }

  componentDidLoad() {
    this.acDetails =
      this.hostElement.shadowRoot.querySelector('.accordion-details');

    this.acSummary =
      this.hostElement.shadowRoot.querySelector('.accordion-summary');
    this.acDetailsContent = this.hostElement.shadowRoot.querySelector(
      '.accordion-details-content',
    );

    // if (Build.isBrowser) {
    this.setTransitionDuration(this.acDetails);
    this.setAcDetailsHeight(this.acDetails);
    // }
  }

  private setTransitionDuration(node: HTMLElement) {
    node.style.transitionDuration = `${this.transitionSpeed}ms`;
  }

  private setAcDetailsHeight(node: HTMLElement) {
    if (this.firstItemIsOpen) {
      addAttribute(this.acDetails, 'open');
      node.style.height = `${this.getDetailHeight()}px`;
    } else if (this.acSummary.clientHeight !== undefined) {
      node.style.height = `${this.acSummary.clientHeight}px`;
    }
  }

  private toggleAcItem(event: Event): void {
    event.preventDefault();
    this.open ? this.closeAcItem() : this.openAcItem();
    this.open = !this.open;
    this.fakeSate = {};
  }

  private openAcItem() {
    addAttribute(this.acDetails, 'open');
    removeClass(this.acDetails, this.isClosedClass);
    this.acDetails.style.height = `${this.getDetailHeight()}px`;
  }

  private getDetailHeight(): number {
    // Calculate height bei using headline- amd content-height as well as space between elements
    return (
      this.acSummary.clientHeight + this.acDetailsContent.clientHeight + 25
    );
  }

  private closeAcItem() {
    addClass(this.acDetails, this.isClosingClass);
    this.acDetails.style.height = `${this.acSummary.clientHeight}px`;
    window.setTimeout(this.isClosing, this.transitionSpeed);
  }

  private isClosing = () => {
    if (hasClass(this.acDetails, this.isClosingClass)) {
      removeAttribute(this.acDetails, 'open');
      removeClass(this.acDetails, this.isClosingClass);
      addClass(this.acDetails, this.isClosedClass);
    }
  };

  private getCssClassMap(): CssClassMap {
    return {
      'is-open': this.open,
      'accordion-details': true,
    };
  }

  private detailsClassMap = this.getCssClassMap();

  render() {
    return (
      <Host
        style={{ visibility: 'visible' }}
        class={{
          'cms-accordion-item': true,
          'first-item-is-open': this.firstItemIsOpen,
        }}
      >
        <details
          class={this.detailsClassMap}
          {...(this.acDetailsAttributes
            ? JSON.parse(this.acDetailsAttributes)
            : {})}
        >
          <summary
            onClick={(event) => this.toggleAcItem(event)}
            onKeyDown={(event) => {
              if (isEnterKey(event)) {
                this.toggleAcItem(event);
              }
            }}
            role='button'
            tabIndex={0}
            class='accordion-summary'
          >
            <div
              class='accordion-headline'
              {...(this.acDetailsAttributes
                ? JSON.parse(this.acHeadlineAttributes)
                : {})}
            >
              {this.acHeadline}
            </div>
            <div class='svg-icon-wrapper'>
              <cms-icon
                size='md'
                icon={this.open ? 'countMinus' : 'countPlus'}
              />
            </div>
          </summary>
          <div class='accordion-details-content'>
            <slot name='accordion-content' />
          </div>
        </details>
      </Host>
    );
  }
}
